import { getTags, getTagsAxios } from '@/api/tags.js';
import { groupByName, sortByName } from '@/scripts/tools.js';


export default {
    state: {
        tags: [],

        isShowTagAdd: false,
        isSaveTagAdd: false,
        tagDataAdd: {
            name: '',
            is_featured: false,
            is_default: false,
        },

        isShowTagEdit: false,
        isSaveTagEdit: false,
        tagDataEdit: null,
    },
    getters: {
        TAGS: state => { return state.tags },
        TAGS_COUNT: state => { return state.tags.length },
        TAGS_BY_ID: (state) => (id) => {
            return state.tags.find((tag) => tag.id === id);
        },
        TAGS_GROUP_BY_NAME: (state) => {
            return groupByName(state.tags);
        },

        IS_SHOW_TAG_ADD: (state) => { return state.isShowTagAdd },
        IS_SAVE_TAG_ADD: (state) => { return state.isSaveTagAdd },
        TAG_DATA_ADD: (state) => { return state.tagDataAdd },

        IS_SHOW_TAG_EDIT: (state) => { return state.isShowTagEdit },
        IS_SAVE_TAG_EDIT: (state) => { return state.isSaveTagEdit },
        TAG_DATA_EDIT: (state) => { return state.tagDataEdit },
    },
    mutations: {
        TAGS: (state, payload) => {
            payload.sort((a, b) => sortByName(a, b));
            state.tags = payload
        },
        TAGS_PUSH: (state, payload) => {
            state.tags.push(structuredClone(payload));
        },
        TAGS_UPDATE: (state, { id, payload }) => {
            const tagIndex = state.tags.map(tag => tag.id).indexOf(id);
            if (tagIndex >= 0) {
                state.tags[tagIndex] = structuredClone(payload);
            }
        },
        PAG_PROVIDER_SPLICE: (state, id) => {
            const tagIndex = state.tags.map(tag => tag.id).indexOf(id);
            if (tagIndex >= 0) state.tags.splice(tagIndex, 1);
        },

        IS_SHOW_TAG_ADD: (state, payload) => { state.isShowTagAdd = payload },
        IS_SAVE_TAG_ADD: (state, payload) => { state.isSaveTagAdd = payload },
        TAG_DATA_ADD_UPDATE: (state, { fieldName, fieldValue }) => {
            state.tagDataAdd[fieldName] = fieldValue;
        },

        IS_SHOW_TAG_EDIT: (state, payload) => { state.isShowTagEdit = payload },
        IS_SAVE_TAG_EDIT: (state, payload) => { state.isSaveTagEdit = payload },
        TAG_DATA_EDIT_SET: (state, payload) => {
            state.tagDataEdit = structuredClone(payload);
        },
        TAG_DATA_EDIT_UPDATE: (state, { fieldName, fieldValue }) => {
            state.tagDataEdit[fieldName] = fieldValue;
        }
    },
    actions: {
        CHECK_TAGS: async function (context) {
            if (context.getters.TAGS.length === 0) {
                context.commit('TAGS', await getTags());
            }
        },
        CHECK_TAGS_AXIOS: async function (context) {
            if (context.getters.TAGS.length === 0) {
                const axiosPromise = await getTagsAxios();
                return axiosPromise;
            }
            return null;
        },
        CHECK_TAG_ADD: async function (context) {
            const data = context.getters.TAG_DATA_ADD;
            if (data.name === '') {
                context.commit('IS_SAVE_TAG_ADD', false);
                return 'To create a tag, enter a name';
            }

            context.commit('IS_SAVE_TAG_ADD', true);
            return '';
        },
        CHECK_TAG_EDIT: async function (context) {
            const data = context.getters.TAG_DATA_EDIT;
            if (data.name === '') {
                context.commit('IS_SAVE_TAG_EDIT', false);
                return 'To save a tag, enter a name';
            }

            context.commit('IS_SAVE_TAG_EDIT', true);
            return '';
        }
    }
}